// Central data service. Talks to the live TMB Global News backend API.
import axios from 'axios';

const API = `https://backend.tmbglobalnews.com/api`;

export async function fetchArticles(category = null) {
  try {
    const params = {};
    if (category) params.category = category;
    const { data } = await axios.get(`${API}/articles`, { params });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('fetchArticles failed', e);
    return [];
  }
}

export async function fetchArticleById(id) {
  try {
    const { data } = await axios.get(`${API}/articles/${id}`);
    return data; // { article, related }
  } catch (e) {
    console.error('fetchArticleById failed', e);
    return { article: null, related: [] };
  }
}

export async function fetchTrending() {
  try {
    const { data } = await axios.get(`${API}/trending`, { params: { limit: 6 } });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('fetchTrending failed', e);
    return [];
  }
}

export async function fetchWeather() {
  try {
    const { data } = await axios.get(`${API}/weather`);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('fetchWeather failed', e);
    return [];
  }
}

export async function fetchTicker() {
  try {
    const { data } = await axios.get(`${API}/ticker`);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('fetchTicker failed', e);
    return [];
  }
}

export async function searchArticles(q) {
  try {
    const term = (q || '').trim();
    if (!term) return [];
    const { data } = await axios.get(`${API}/search`, { params: { q: term } });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('searchArticles failed', e);
    return [];
  }
}

export async function submitAdInquiry(payload) {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
}
